/**
 *  @class
 *  @function VerbruikCalculator
 */
if (!customElements.get('verbruik-calculator')) {
  class VerbruikCalculator extends HTMLElement {
    constructor() {
      super();
      this.verbruik = parseFloat(this.dataset.verbruik);
      this.inhoud = parseFloat(this.dataset.inhoud);
    }

    connectedCallback() {
      this.inputM2 = this.querySelector('[data-calculator-m2]');
      this.inputMm = this.querySelector('[data-calculator-mm]');
      this.result = this.querySelector('[data-calculator-result]');
      // meerdere plekken: resultaatregel + mobiele "Neem N zakken over"-knop
      this.resultValues = this.querySelectorAll('[data-calculator-result-value]');
      this.resultLabels = this.querySelectorAll('[data-calculator-result-label]');

      if (!this.inputM2 || !this.inputMm || !this.result || !this.resultValues.length) return;

      this.inputM2.addEventListener('input', this.calculate.bind(this));
      this.inputMm.addEventListener('input', this.calculate.bind(this));
    }

    calculate() {
      const m2 = parseFloat(this.inputM2.value);
      const mm = parseFloat(this.inputMm.value);

      if (!(m2 > 0) || !(mm > 0) || !(this.verbruik > 0) || !(this.inhoud > 0)) {
        this.result.hidden = true;
        return;
      }

      const zakken = Math.ceil((m2 * mm * this.verbruik) / this.inhoud);
      this.resultValues.forEach((el) => {
        el.textContent = zakken;
      });
      const zakLabel = zakken === 1 ? 'zak' : 'zakken';
      this.resultLabels.forEach((el) => {
        el.textContent = zakLabel;
      });
      this.result.hidden = false;
    }
  }
  customElements.define('verbruik-calculator', VerbruikCalculator);
}
